import { KCopyButton, KSelect, KTextField } from "kinnect-general";
import { ResizeWatchable } from "kinnect-mixins";
import {
	VCard,
	VCardActions,
	VCardText,
	VCardTitle,
	VCol,
	VRow,
	VSpacer
} from "vuetify/lib";

export default {
	name: "CubicFeetCalculator",

	mixins: [ ResizeWatchable ],

	data: () => ( {
		height: null,
		heightUnits: 1 / 12,
		length: null,
		lengthUnits: 1,
		units: [
			{
				text: "Inches",
				value: 1 / 12
			},
			{
				text: "Feet",
				value: 1
			}
		],
		width: null,
		widthUnits: 1
	} ),

	computed: {
		scaledHeight() {
			return this.height * this.heightUnits;
		},

		scaledLength() {
			return this.length * this.lengthUnits;
		},

		scaledWidth() {
			return this.width * this.widthUnits;
		},

		cubicFeet() {
			if ( this.scaledHeight && this.scaledLength && this.scaledWidth ) {
				return parseFloat( ( this.scaledHeight * this.scaledLength * this.scaledWidth ).toFixed( 2 ) );
			}
		},

		narrowContainer() {
			return this.elWidth < 600;
		}
	},

	watch: {
		cubicFeet( cubicFeet ) {
			this.$emit( "valueUpdate", cubicFeet );

			if ( cubicFeet ) {
				this.$ga.event( {
					eventCategory: "Cubic Feet Calculator",
					eventAction: "Calculated",
					eventLabel: `${this.scaledLength}ft L x ${this.scaledWidth}ft W x ${this.scaledHeight}ft H = ${cubicFeet} cubic feet`
				} );
			}
		}
	},

	render() {
		return <VRow>
			<VCol cols={12}>
				<h1 class="text-h4">Cubic Feet Calculator</h1>
			</VCol>

			<VCol cols={this.narrowContainer ? 12 : 6}>
				<VCard>
					<VCardTitle>Input</VCardTitle>

					<VCardText>
						<form>
							<VRow>
								<VCol cols={5}>
									<KTextField
										hideDetails
										label="Length"
										type="number"
										vModel={this.length}
									></KTextField>
								</VCol>

								<VCol cols={7}>
									<KSelect
										hideDetails
										items={this.units}
										label="Length Units"
										vModel={this.lengthUnits}
									></KSelect>
								</VCol>
							</VRow>

							<VRow>
								<VCol cols={5}>
									<KTextField
										hideDetails
										label="Width"
										type="number"
										vModel={this.width}
									></KTextField>
								</VCol>

								<VCol cols={7}>
									<KSelect
										hideDetails
										items={this.units}
										label="Width Units"
										vModel={this.widthUnits}
									></KSelect>
								</VCol>
							</VRow>

							<VRow>
								<VCol cols={5}>
									<KTextField
										hideDetails
										label="Height"
										type="number"
										vModel={this.height}
									></KTextField>
								</VCol>

								<VCol cols={7}>
									<KSelect
										hideDetails
										items={this.units}
										label="Height Units"
										vModel={this.heightUnits}
									></KSelect>
								</VCol>
							</VRow>
						</form>
					</VCardText>
				</VCard>
			</VCol>

			<VCol cols={this.narrowContainer ? 12 : 6}>
				<VCard>
					<VCardTitle>Results</VCardTitle>

					<VCardText>
						<KTextField
							hideDetails
							label="Total Cubic Feet"
							readonly
							ref="cubicFeet"
							value={this.cubicFeet}
						></KTextField>
					</VCardText>

					<VCardActions>
						<VSpacer></VSpacer>
						<KCopyButton text value={this.cubicFeet}></KCopyButton>
					</VCardActions>
				</VCard>
			</VCol>
		</VRow>;
	}
};
